import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Languages, X } from 'lucide-react'
import { LOCALE } from '../i18n'

const STORAGE_KEY = 'apav-translation-notice-dismissed'

/**
 * Aviso de tradução automática — só nas versões ≠ pt.
 * Diz quem traduziu (eTranslation da Comissão Europeia, ou IA nas línguas
 * que o eTranslation não cobre a partir do português), que não houve revisão
 * humana, e que o original em português prevalece. Dispensável, guardado em
 * localStorage — não é cookie e não sai do dispositivo.
 *
 * Fica no topo do <main>, que no Layout já tem `pt-16 lg:pt-20` para a navbar
 * fixa. Leva ainda `pt-8` porque o logótipo da navbar transborda 32px para
 * dentro do conteúdo (h-24/h-28 numa barra de h-16/h-20) e tapava o aviso.
 */
export default function TranslationNotice() {
    const { t } = useTranslation()
    const [dismissed, setDismissed] = useState(() => {
        try {
            return localStorage.getItem(STORAGE_KEY) === '1'
        } catch {
            return false
        }
    })

    if (LOCALE === 'pt' || dismissed) return null

    const dismiss = () => {
        try {
            localStorage.setItem(STORAGE_KEY, '1')
        } catch {
            /* sem storage, o aviso volta na próxima página — aceitável */
        }
        setDismissed(true)
    }

    return (
        <div role="note" aria-label={t('translationNotice.aria')} className="border-b border-slate-200 bg-slate-100 text-slate-700">
            <div className="mx-auto flex max-w-7xl items-start gap-2.5 px-4 pt-8 pb-2.5 text-xs sm:items-center sm:px-6 sm:text-sm lg:px-8">
                <Languages size={16} className="mt-0.5 shrink-0 text-brand-600 sm:mt-0" aria-hidden="true" />
                <p className="flex-1 leading-snug m-0">
                    {t('translationNotice.body')}{' '}
                    <a href="/" hrefLang="pt" lang="pt" className="whitespace-nowrap font-semibold underline transition-colors hover:text-brand-700">
                        {t('translationNotice.viewOriginal')}
                    </a>
                </p>
                <button
                    type="button"
                    onClick={dismiss}
                    aria-label={t('translationNotice.dismiss')}
                    className="shrink-0 rounded p-1 transition-colors hover:text-brand-700 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-brand-500"
                >
                    <X size={14} aria-hidden="true" />
                </button>
            </div>
        </div>
    )
}
